import React from 'react';
import {Divider} from 'antd';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({link,novel_id, name, pic, is_done, cata, brief}) => (
<div>
    {/*<Link to={`/book/detail/${novel_id}`}>*/}
    <Link to={`${link}`}>
        <div style={{
            width: '100%',
            paddingBottom: '128.6%',
            height: '0',
            backgroundImage: `url(${pic})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
        }} />
        <div style={{
            fontSize: '16px',
            lineHeight: '22px',
            color: '#333333',
            textAlign: 'center',
            marginTop: '10px',
        }}>{name}</div>
        <div style={{
            fontSize: '12px',
            lineHeight: '17px',
            color: '#999999',
            textAlign: 'center',
            marginTop: '10px',
        }}>{cata}<Divider type='vertical'/>{is_done ? '已完结' : '未完结'}</div>
        <div style={{
            fontSize: '12px',
            lineHeight: '17px',
            color: '#999999',
            textAlign: 'center',
            marginTop: '10px',
        }}>
			<LinesEllipsis text={brief} maxLine={3} />
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_5.js